import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";
import { SectionContainer } from "@repo/ui";

export const ListContainer = styled(SectionContainer)`
  gap: ${Variables.space125};
`;
